import { checkResponse } from "src/components/js/statics1";

export async function aiAsk(prompt, ownerAsiakasId, conversationId, keikkaId, token) {
  try {
    const url = "/api/ai/ask";
    const response = await fetch(import.meta.env.VITE_SERVER_URL + url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": `${token}`,
      },
      body: JSON.stringify({ prompt, ownerAsiakasId, conversationId, keikkaId }),
    });
    const cResponse = await checkResponse(response, "gptAsk");
    if (cResponse.success === false) return false;
    const result = cResponse.data;
    return result;
  } catch (error) {
    console.log("gptAsk error:", error);
    return false;
  }
}
